import {getRestaurantsVisits, getRestaurantVisits} from './visits';
import {
  addRestaurantToFavoriteList,
  createFavoriteList,
  deleteFavoriteList,
  deleteRestaurantFromFavoriteList,
  getFavoritesList,
  getFavoritesLists,
  getUserFavoritesLists,
  getUserFavoritsLists,
  updateFavoriteList
} from './favorite'
import {createUserFollower, deleteUserFollow} from './follow/follow';
import {getUser, getUsers} from './user/user';
import {getToken, login, logout, signup} from './user/authentification';


import RestaurantServices, {getRestaurantById, getRestaurants} from "../services/restaurant";

export default class Api {
  constructor() {
    this.deleteUserFollow = deleteUserFollow
    this.createUserFollower = createUserFollower

    this.getToken = getToken;
    this.logout = logout;
    this.signup = signup;
    this.login = login;
    this.getRestaurantsVisits = getRestaurantsVisits;
    this.getRestaurantVisits = getRestaurantVisits;
    this.createFavoriteList = createFavoriteList;
    this.getUserFavoritsLists = getUserFavoritsLists;
    this.getUser = getUser;
    this.getUsers = getUsers;
    this.getFavoritesLists = getFavoritesLists;
    this.getFavoritesList = getFavoritesList;
    this.deleteFavoriteList = deleteFavoriteList;
    this.addRestaurantToFavoriteList = addRestaurantToFavoriteList;
    this.getRestaurantInfoFromApi = RestaurantServices.getRestaurantInfoFromApi
    this.getRestaurants = getRestaurants
    this.deleteRestaurantFromFavoriteList = deleteRestaurantFromFavoriteList;
    this.updateFavoriteList = updateFavoriteList;
    this.getRestaurantById = getRestaurantById;
    this.addRestaurantToFavoriteList = addRestaurantToFavoriteList;
    this.getUserFavoritesLists = getUserFavoritesLists;
    this.getRestaurants = getRestaurants;
    this.deleteRestaurantFromFavoriteList = deleteRestaurantFromFavoriteList;
    this.updateFavoriteList = updateFavoriteList;
  }

}
